module.exports = __webpack_public_path__ + "static/logo.0d4b1830.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/Header/logo.png
// module id = 650
// module chunks = 97291517795586 114276838955818